/**
 * ajax请求配置
 */
import axios from 'axios'
import router from '../router/index'
import { apiUrl } from './config'
import Qs from 'qs'

// axios默认配置
axios.defaults.timeout = 10000;   // 超时时间
// axios.defaults.baseURL = apiURL;  // 默认地址

//整理数据
axios.defaults.transformRequest = function (data) {
    //data = Qs.stringify(data);
    data = JSON.stringify(data);
    return data;
};

// axios.defaults.transformRequest = [
//   function(data) {
//     return JSON.stringify(data);
//   }
// ]

// 路由请求拦截
// http request 拦截器
axios.interceptors.request.use(
    config => {
        config.url = apiUrl + config.url;
        config.headers['Content-Type'] = 'application/json;charset=UTF-8';
        config.headers.Authorization = "Bearer eyJhbGciOiJIUzI1NiJ9.eyJzdWIiOiJtaW4tcHJvZ3JhbSIsInIiOjQxMDc5LCJkIjoxLCJybyI6Im1pbi1wcm9ncmFtIiwidHMiOjE1NzcwNjMzOTkwOTB9.XXyHZIODO27Kzr-5981cN9Vv1Y6zQ_NvZyZ2LxsyIwc";
        if(config.url.includes('updateRankReward') && localStorage.getItem('watch_auth')){
            config.headers.Authorization = ("Bearer "+localStorage.getItem('watch_auth'));
            console.log("get watch auth from localStorage "+config.headers.Authorization);
        }
        return config;
    },
    error => {
        return Promise.reject(error.response);
    });

// 路由响应拦截
// http response 拦截器
axios.interceptors.response.use(
    response => {
        if (response.data.code == '401') {
            router.push("/login");
            return response.data;
        } else{
            return response.data;
        }
    },
    error => {
        console.log(error)
        // return Promise.reject(error.response)   // 返回接口返回的错误信息
    });
export const get = (url, data = {}) => {
    return axios.get(url, { params: data, });
};
export const post = (url, data={}) => {
    return axios.post(url, data)
};

export const put = (url, data={}) => {
    return axios.put(url, data)
};
  export const arrget = (url, data = {}) => {
    return axios.get(url, {
        params:data,
        paramsSerializer: function(params) {
            return Qs.stringify(params, {arrayFormat: 'repeat'})
        }
    });
};
export default axios;
